module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Thalheim_AG-13451794bf42519fc4bfdd1d7bb8789e.svg";